export enum ZerosixRegistrationStep {
  ZEROSIX_STEP_PHONE = 'ZEROSIX_STEP_PHONE',
  ZEROSIX_STEP_OTP = 'ZEROSIX_STEP_OTP',
  ZEROSIX_STEP_AUTHENTICATION = 'ZEROSIX_STEP_AUTHENTICATION',
  ZEROSIX_STEP_ACCOUNT_NOT_FOUND = 'ZEROSIX_STEP_ACCOUNT_NOT_FOUND',
  ZEROSIX_STEP_KIOSK_CONFIRMATION = 'ZEROSIX_STEP_KIOSK_CONFIRMATION',
  ZEROSIX_STEP_KIOSK_REGISTER = 'ZEROSIX_STEP_KIOSK_REGISTER',
  ZEROSIX_STEP_KIOSK_REGISTER_CONFIRMATION = 'ZEROSIX_STEP_KIOSK_REGISTER_CONFIRMATION',
  ZEROSIX_STEP_KIOSK_REGISTRATION_SUCCESS = 'ZEROSIX_STEP_KIOSK_REGISTRATION_SUCCESS',
  ZEROSIX_STEP_KIOSK_ACCOUNT_NOT_FOUND = 'ZEROSIX_STEP_KIOSK_ACCOUNT_NOT_FOUND',
}
